import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import DashUserLoadStatusViewForm from './DashUserLoadStatusViewForm'
import DashUserLoadStatusAddForm from './DashUserLoadStatusAddForm'
import DashUserLoadStatusEditForm from './DashUserLoadStatusEditForm'
import Namespace from 'src/constants/locale/Namespace'
import DashUserLoadStatusKeys from 'src/constants/locale/key/ForwardHub'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [dashLoadStatusId, setDashUserLoadStatusId] = useState('')
  const { translate } = useTranslation([
    Namespace.DASH_LOAD_STATUS,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let dashLoadStatus = translate(
      Namespace.DASH_LOAD_STATUS,
      DashUserLoadStatusKeys.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: dashLoadStatus
      }
    )

    return {
      dashLoadStatus,
      tabLockedMessage
    }
  }

  function makeDashUserLoadStatusForm() {
    if (dashLoadStatusId === '') {
      return (
        <DashUserLoadStatusAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            setDashUserLoadStatusId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <DashUserLoadStatusEditForm
          showNotification={showNotification}
          id={dashLoadStatusId}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <DashUserLoadStatusViewForm
              showNotification={showNotification}
              id={dashLoadStatusId}
            />
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.dashLoadStatus,
              tabContent: makeDashUserLoadStatusForm()
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage